/* eslint-disable react-hooks/exhaustive-deps */
import { Page, Text, View, Document, StyleSheet, pdf, Font, Image } from "@react-pdf/renderer";
import { formatPrice } from '../../utils';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../assets/fonts/rudawregular2.ttf';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import JsBarcode from 'jsbarcode';
import PostService from '../../services/postService';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import QRCode from 'qrcode';
import { useCompany } from '../../provider/companyProvider';
import { fileApiRoute } from "../../services/networkService";


const registerFont = () => {
    Font.register({
        family: 'Rudaw',
        fonts: [{ src: Rudaw, fontWeight: 'normal' }],
    });
};

const PdfOnePostV2 = ({ id }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language !== 'en';
    const [post, setPost] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [qrCodeImage, setQrCodeImage] = useState('');
    const { business } = useCompany();

    const styles = StyleSheet.create({
        row: {
            flexDirection: isRTL ? 'row-reverse' : 'row',
            alignItems: 'center',
            paddingHorizontal: 4
        },
        key: {
            fontWeight: 'bold',
            width: '40%',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
            fontSize: 9
        },
        value: {
            flex: 1,
            textAlign: isRTL ? 'right' : 'left',
            paddingHorizontal: 2,
            fontSize: 9
        },
        barcode: {
            width: '50%',
            height: 52,
            alignSelf: 'center',
            marginVertical: 1
        },
        qrcode: {
            width: 60,
            height: 60,
            alignSelf: 'center',
        },
        footer: {
            textAlign: "center",
            fontSize: 8,
            marginTop: 2,
            color: "#000"
        }
    });

    const generateBarcode = (text) => {
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, text, { format: "CODE128", displayValue: false });
        return canvas.toDataURL('image/png');
    };

    const generateQrCode = async (text) => {
        try {
            const url = await QRCode.toDataURL(text);
            setQrCodeImage(url);
            return url;
        } catch (err) {
            console.error('Error generating QR code:', err);
            return '';
        }
    };


    const MyDocument = () => {
        const barcodeImage = generateBarcode(post.id);

        return (
            <Document>
                <Page size="A6" style={{
                    padding: 4,
                    direction: isRTL ? 'rtl' : 'ltr',
                    fontFamily: 'Rudaw',
                    height: "auto",
                    overflow: 'hidden'
                }}>
                    <View style={{
                        border: "1px solid #000",
                        textAlign: isRTL ? 'right' : 'left',
                        fontSize: 10,
                    }}>
                        <View style={{
                            display: 'flex',
                            direction: isRTL ? 'rtl' : 'ltr',
                            flexDirection: isRTL ? 'row-reverse' : 'row',
                            justifyContent: 'space-between'
                        }}>
                            {/* qrcode */}
                            <View style={{
                                display: 'flex',
                                direction: isRTL ? 'rtl' : 'ltr',
                                flexDirection: isRTL ? 'row-reverse' : 'row',
                                width: '60%'
                            }}>
                                {qrCodeImage && (
                                    <Image style={styles.qrcode} src={qrCodeImage} />
                                )}

                                <View
                                    style={{
                                        marginVertical: 12,
                                        direction: isRTL ? 'rtl' : 'ltr',
                                        alignItems: isRTL ? 'flex-end' : 'flex-start',
                                    }}
                                >
                                    <Text>{business?.name}</Text>
                                    <Text>{t('id')}: {post.id}</Text>
                                    {/* <Text>{dayjs().format('DD/MM/YYYY HH:mm:ss')}</Text> */}
                                    <Text>{post.createdAt}</Text>
                                </View>

                            </View>

                            <View style={{
                                width: '40%',
                            }}>
                                {/* logo */}
                                <Image style={{
                                    width: '65%',
                                    alignSelf: "center",
                                }} src={`${fileApiRoute}/${business.logo}`} />
                            </View>

                        </View>

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginBottom: 4 }} />

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('driver')}:</Text>
                            <Text style={styles.value}>{post.driver?.name}</Text>
                        </View>

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginVertical: 4 }} />

                        {/* Address Info */}
                        <View style={styles.row}>
                            <Text style={styles.key}>{t('address')}:</Text>
                            <Text style={styles.value}>{`${post.receiverAddress}, ${post.street.name}, ${post.street.city.name}`}</Text>
                        </View>

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginVertical: 4 }} />

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('receiverName')}:</Text>
                            <Text style={styles.value}>{post.receiverName}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('receiverPhone')}:</Text>
                            <Text style={styles.value}>{post.receiverPhone}, {post.receiverPhoneTwo}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('postType')}:</Text>
                            <Text style={styles.value}>{post.postType.name}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('totalPrice')}:</Text>
                            <Text style={styles.value}>{formatPrice(post.totalPrice)}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('supervisor')}:</Text>
                            <Text style={styles.value}>{post.driver && post.driver.supervisor.name}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('note')}:</Text>
                            <Text style={{ ...styles.value, fontSize: 8 }}>
                                {(post.note) ? `${(post.note).slice(0, 136)}${(post.note).length > 136 ? '...' : ''}` : '-'}
                            </Text>

                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginVertical: 4 }} />

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('pageName')}:</Text>
                            <Text style={styles.value}>{post.page?.name}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={styles.row}>
                            <Text style={styles.key}>{t('pagePhone')}:</Text>
                            <Text style={styles.value}>{post.page?.phone}</Text>
                        </View>
                        <View style={{ height: 3 }}></View>

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginVertical: 4 }} />
                        {/* Barcode */}
                        <Image style={styles.barcode} src={barcodeImage} />

                        <View style={{ borderBottomWidth: '1px', borderColor: "#000", marginVertical: 4 }} />
                        <Text style={{ paddingHorizontal: 4, fontSize: 9 }}>{business?.name}</Text>
                        <Text style={{ paddingHorizontal: 4, fontSize: 9 }}>{business?.addressOne}</Text>
                        <Text style={{ paddingHorizontal: 4, fontSize: 9 }}>{business?.addressTwo}</Text>
                        <Text style={{ paddingHorizontal: 4, fontSize: 9 }}>{business?.phoneOne} - {business?.phoneTwo}</Text>
                    </View>
                </Page>
            </Document>
        );
    };

    const fetchPost = async () => {
        try {
            setIsLoading(true);
            const data = await PostService.fetchOne(id);
            setPost(data);
            await generateQrCode(data.id.toString());
        } catch (error) {
            console.error("Failed to fetch post:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = async () => {
        registerFont();
        await fetchPost();
    };

    useEffect(() => {
        if (post) {
            (async () => {
                try {
                    const blob = await pdf(<MyDocument />).toBlob();
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        console.error("Failed to generate PDF blob.");
                    }
                } catch (error) {
                    console.error("Error generating PDF:", error);
                }
            })();
        }
    }, [post]);

    return (
        <>
            {isLoading ? (
                <CircularProgress size={20} />
            ) : (
                <PictureAsPdfOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />
            )}
        </>
    );
}

export default PdfOnePostV2;